import type { SchemaField, WalkFieldsOptions } from '@cli-types/core-engine/schema.js'
import { someField } from './some-field.js'

export function hasAnyFieldType(
  fields: SchemaField[],
  types: string[],
  options?: WalkFieldsOptions
): boolean {
  return someField(fields, (field) => types.includes(field.type), options)
}
